import React from 'react';

import Date from '../../Types/Components/Date';
import CardHOC from './Components/CardHOC';

export default function (props) {
  return <CardHOC question={props.question}>
    <Date {...props} />
  </CardHOC>
}